/**
 * @file   src\components\OrderAddCart.tsx
 * @brief  OrderAddCart component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import {  useEffect, useState } from 'react';
import Deviceicon from '../assets/images/computer-chip.svg';
import CWSelect from '../components/CWSelect';
import { Button } from 'react-bootstrap';
import CloseIcon from '../assets/images/icons/close';
import { IOrderData } from '../interfaces/hardwareInterface';
import React from 'react';



interface OrderAddCartProps {
    cartData:IOrderData;
    deleteItem: (id: string) => void;
    deletePackage:(item:any)=>void;
    updateQuantity: (id: string, quantity: number) => void;
}

const OrderAddCart = ({ cartData, deleteItem,deletePackage, updateQuantity }: OrderAddCartProps) => {
    const [selectedQuantities, setSelectedQuantities] = useState<{ [key: string]: number }>({});
    const [grandTotal, setGrandTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const initialFee = cartData.initialFee
    useEffect(() => {
        // Calculate the initial grand total on mount
        let initialTotal = Object.values(cartData.devices).reduce(
            (total, device) => total + device.price * device.quantity,
            0
        ) 
        if( cartData.packageItems)
            initialTotal = initialTotal+ cartData.packageItems?.packagePrice;
        setTotal(initialTotal)
        setGrandTotal(initialTotal+initialFee);
    }, [cartData.devices]);

    // Handle quantity change
    const handleSelectChange = (id: string, quantity: number) => {
        setSelectedQuantities((prev) => ({
            ...prev,
            [id]: quantity
        }));
        updateQuantity(id, quantity);
    }

    useEffect(() => {
        // Recalculate the grand total whenever selected quantities or cart data changes
        let newTotal = Object.values(cartData.devices).reduce(
            (total, device) => total + device.price * device.quantity,
            0
        )
        if( cartData.packageItems)
            newTotal = newTotal+ cartData.packageItems?.packagePrice;
        setTotal(newTotal)
        setGrandTotal(newTotal+initialFee);
    }, [selectedQuantities, cartData.devices,cartData.packageItems]);

    return (
        <div className="order-cart-wrap mx-auto">
            <div className="cart-item-list d-flex flex-column">
                {Object.entries(cartData.devices).map(([id, device], index) => (
                    <div className="product-card d-flex position-relative" key={id}>
                        <Button variant="light" className="light-btn close-btn" onClick={()=>deleteItem(id)}>
                            <CloseIcon />
                        </Button>
                        <div className={`device-frame ${device.image ? 'device-img' : ''} m-0 d-flex align-items-center justify-content-center`}>
                            <img src={device.image ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH || ""}${device.image}` : Deviceicon} alt="Device Icon" />

                        </div>
                        <div className="product-info">
                            <h5 className='f-bold'>{device.hardwareName}</h5>
                            <h2 className='f-bold'>${device.price}</h2>
                            <div className="quantity-select d-flex align-items-end justify-content-between">
                                <CWSelect
                                    id={`quantity${index + 1}`}
                                    name={`quantity${index + 1}`}
                                    options={Array.from({ length: 10 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` }))}
                                    dropdownGap={0}
                                    dropdownPosition="auto"
                                    multi={false}
                                    label="Quantity"
                                    values={[{ label: `${device.quantity}`, value: `${device.quantity}` }]}
                                    onChange={(selectedOption) => handleSelectChange(id, parseInt(selectedOption[0].value))}
                                />
                            </div>
                        </div>
                    </div>
                ))}
                {/* selected package  */}
               {cartData.packageItems && <div className="product-card d-flex position-relative" key={cartData.packageItems?.packageId}>
                        <Button variant="light" className="light-btn close-btn" onClick={()=>deletePackage(cartData.packageItems)}>
                            <CloseIcon />
                        </Button>
                        <div className={`device-frame ${cartData.packageItems?.packageImage ? 'device-img' : ''} m-0 d-flex align-items-center justify-content-center`}>

                        <img src={cartData.packageItems?.packageImage ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH || ""}${cartData.packageItems?.packageImage}` : Deviceicon} alt="Marketing Package" />
                        </div>
                        <div className="product-info">
                            <h5 className='f-bold'>{cartData.packageItems?.packageName}</h5>
                            <h2 className='f-bold'>${cartData.packageItems?.packagePrice}</h2>
                            {/* <div className="quantity-select d-flex align-items-end justify-content-between">
                                <CWSelect
                                    id={`package${cartData.packageItems?.packageId}`}
                                    name={`quantity${index + 1}`}
                                    options={Array.from({ length: 10 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` }))}
                                    dropdownGap={0}
                                    dropdownPosition="auto"
                                    multi={false}
                                    label="Quantity"
                                    values={[{ label: `${device.quantity}`, value: `${device.quantity}` }]}
                                    onChange={(selectedOption) => handleSelectChange(id, parseInt(selectedOption[0].value))}
                                />
                            </div> */}
                        </div>
                    </div>}
            </div>

            <div className="payment-amount-block">
            <div className="inner-wrap">
                    <div className="total-group price-info d-flex align-items-end flex-column">
                        <div className="price d-flex align-items-center">
                            <p className='f-bold'>Total:</p>
                            <h3 className='f-bold'>${total}</h3>
                        </div>
                        { initialFee > 0 &&<div className="price d-flex align-items-center">
                            <p className='f-bold'>Initial Fee:</p>
                            <h3 className='f-bold'>${initialFee}</h3>
                        </div>}
                    </div>
                    <div className="price-info">
                        <div className="price d-flex align-items-center justify-content-end">
                            <p className='f-bold'>Grand Total:</p>
                            <h3 className='f-bold total'>${grandTotal}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderAddCart;
